import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BrandsServiceService } from 'src/app/Services/brands-service.service';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { StaticPagesService } from 'src/app/Services/static-pages.service';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss']
})
export class BrandsComponent implements OnInit {
brandsList:any =[]
        brandTypeData = {
       isSlider:'',
       isSqure:'',
    };
       nameRouting: any = [];
     environmentVariables: any;
     lang: any;
  constructor( private brandsService: BrandsServiceService, 
     private confgServ: StaticPagesService,
     private translate: TranslateService,
     public embryoService: EmbryoService,
      private router: Router,
     ) { 

          this.getInitilizingData();
        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
        });
     }

  ngOnInit(): void {
    this.getBrandsData(1);
    this.getInitilizingData();
    this.nameRouting.push({name_en: 'brands', name_ar: 'الماركات'})
  }

  getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.brandTypeData.isSlider = this.environmentVariables.BRANDS_STYLE;
            this.brandTypeData.isSqure = this.environmentVariables.BRANDS_CARD;
            // console.log(this.brandTypeData);
            
        });
    }
     getBrandsData(page:any) {
        this.brandsService.getBrands(page).subscribe((res: any) => {
            if (res.code == 200) {
                this.brandsList = res?.data.items;
                this.totalPage = res.data.total;
                // console.log( this.brandsList );
                
            }
        });
    }
  currentPage :any;
    totalPage: number = 0;
      onPageChanged(pageNumber: number) {
        this.currentPage = pageNumber;
        this.getBrandsData(this.currentPage);
    }


       redirectToBrand(data: any) {
        if (data?.has_images)
            this.router.navigate([`/${this.lang}/brand`, data?.id]);
        else
            this.router.navigate([`/${this.lang}/products`], {
                queryParams: { brand_id: data?.id, page: 1 },
            });
    }
}
